var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-header-nav-more-social"},_vm._l((_vm.socials),function(social,index){return _c('app-header-nav-more-social-item',{key:index,attrs:{"social":social}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }